var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-dialog" }, [
    _c("div", { staticClass: "modal_content" }, [
      _c("div", { staticClass: "modal_header" }, [
        _c("h5", [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("sdl.approval.label.requiredApprovalUser")) +
              " " +
              _vm._s(_vm.$t("sdl.common.label.search")) +
              "\n      "
          )
        ]),
        _vm._v(" "),
        _c("button", {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          },
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal_body" }, [
        _c("div", { staticClass: "list_wrap" }, [
          _c("div", { staticClass: "scop_grid h_auto" }, [
            _c("table", [
              _c("colgroup", [
                _c("col", { attrs: { width: "50px" } }),
                _vm._v(" "),
                _c("col"),
                _vm._v(" "),
                _c("col"),
                _vm._v(" "),
                _c("col"),
                _vm._v(" "),
                _c("col"),
                _vm._v(" "),
                _vm.cspInfo.show ? _c("col") : _vm._e(),
                _vm._v(" "),
                _vm.divisionShow ? _c("col") : _vm._e()
              ]),
              _vm._v(" "),
              _c("thead", [
                _c("tr", [
                  _c("th", { attrs: { scope: "col" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectAll,
                          expression: "selectAll"
                        }
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.selectAll)
                          ? _vm._i(_vm.selectAll, null) > -1
                          : _vm.selectAll
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                        },
                        change: [
                          function($event) {
                            var $$a = _vm.selectAll,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.selectAll = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.selectAll = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.selectAll = $$c
                            }
                          },
                          _vm.toggleSelectAll
                        ]
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("th", { attrs: { scope: "col" } }, [
                    _vm._v(_vm._s(_vm.$t("sdl.user.label.knoxId")))
                  ]),
                  _vm._v(" "),
                  _c("th", { attrs: { scope: "col" } }, [
                    _vm._v(_vm._s(_vm.$t("sdl.common.label.name")))
                  ]),
                  _vm._v(" "),
                  _c("th", { attrs: { scope: "col" } }, [
                    _vm._v(_vm._s(_vm.$t("sdl.user.label.deptName")))
                  ]),
                  _vm._v(" "),
                  _c("th", { attrs: { scope: "col" } }, [
                    _vm._v(_vm._s(_vm.$t("sdl.user.label.mobile")))
                  ]),
                  _vm._v(" "),
                  _vm.cspInfo.show
                    ? _c("th", { attrs: { scope: "col" } }, [
                        _vm._v("CSP in charge")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.divisionShow
                    ? _c("th", { attrs: { scope: "col" } }, [
                        _vm._v("Division")
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(_vm.userList, function(user) {
                    return _c("tr", { key: user.userId }, [
                      _c("td", { staticClass: "text-center" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: user.selected,
                              expression: "user.selected"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(user.selected)
                              ? _vm._i(user.selected, null) > -1
                              : user.selected
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$a = user.selected,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        user,
                                        "selected",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        user,
                                        "selected",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(user, "selected", $$c)
                                }
                              },
                              function($event) {
                                return _vm.selectRow(user)
                              }
                            ]
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-left",
                          attrs: { title: user.user.knoxId }
                        },
                        [_vm._v(_vm._s(user.user.knoxId))]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-left",
                          attrs: {
                            title:
                              _vm.locale === "ko_KR"
                                ? user.user.userName
                                : user.user.userNameEn
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.locale === "ko_KR"
                                ? user.user.userName
                                : user.user.userNameEn
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-left",
                          attrs: {
                            title:
                              _vm.locale === "ko_KR"
                                ? user.user.deptName
                                : user.user.deptNameEn
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.locale === "ko_KR"
                                ? user.user.deptName
                                : user.user.deptNameEn
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "text-left",
                          attrs: { title: user.user.mobile }
                        },
                        [_vm._v(_vm._s(user.user.mobile))]
                      ),
                      _vm._v(" "),
                      _vm.cspInfo.show
                        ? _c(
                            "td",
                            {
                              staticClass: "text-left",
                              attrs: { title: user.cspCodes }
                            },
                            [_vm._v(_vm._s(user.cspCodes))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.divisionShow
                        ? _c(
                            "td",
                            {
                              staticClass: "text-left",
                              attrs: { title: user.divisionCd }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.getDivisionLabel(user.divisionCd))
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  }),
                  _vm._v(" "),
                  _c(
                    "tr",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.userList.length === 0,
                          expression: "userList.length === 0"
                        }
                      ]
                    },
                    [
                      _c(
                        "td",
                        {
                          attrs: {
                            colspan: _vm.cspInfo.show
                              ? _vm.divisionShow
                                ? 7
                                : 6
                              : 5
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("sdl.common.message.noResult")) + " "
                          )
                        ]
                      )
                    ]
                  )
                ],
                2
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal_footer" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-secondary",
            attrs: { type: "button", "data-dismiss": "modal" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("sdl.common.label.cancel")) +
                "\n      "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            attrs: { type: "button" },
            on: { click: _vm.rtnData }
          },
          [_vm._v(_vm._s(_vm.$t("sdl.common.label.confirm")))]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a7f98d9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a7f98d9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/admin/approval/popup/RequiredApprListPopup.vue
// module id = null
// module chunks = 